
export default {
  name: 'BlogShare',
  props: ['document'],
  data() {
    return {
      navigatorShare: false
    }
  },
  computed: {
    shareData() {
      return {
        url: 'https://vitesy.com' + this.$route.path,
        title: this.$prismic.asText(this.document.title),
        text:
          this.document.seo_description || this.document.content?.length
            ? this.$prismic.asText(this.document.content)
            : ''
      }
    }
  },
  mounted() {
    if (navigator.share) {
      this.navigatorShare = true
    }
  },
  methods: {
    share() {
      navigator.share(this.shareData)
    }
  }
}
